enum GrantTypes {
  Mfa = 'mfa',
  TokenExchange = 'tokenExchange',
  Password = 'password',
  RefreshToken = 'refreshToken'
}

export default GrantTypes;
